module.exports = __webpack_public_path__ + "static/img/头像2.fe55326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/头像2.png
// module id = ztPu
// module chunks = 1